import Clientlisting from '../views/client/clientlisting';
import ClientRatesListing from '../views/ClientRates/ClientRatesListing';
import ClientContractListing from '../views/ClientContract/ClientContractListing';
import ClientServicesListing from '../views/ClientServices/ClientServicesListing';
import ClientTCListing from '../views/ClientTC/ClientTCListing';
import ClientAnnexuresListing from '../views/ClientAnnexures/ClientAnnexuresListing';
import ClientLocations from '../views/ClientLocations/UploadLocationListing';
import ClientHubs from '../views/clienthubs';


export default [
  {
    path: '/cargoclient/client',
    name: 'cargoclient-client',
    component: Clientlisting,
    title: 'cargoclient-client',
    meta: {
      requiresAuth: true
    }
  }
  ,{
    path: '/cargoclient/contracts',
    name: 'cargoclient-clientContractListing',
    component: ClientContractListing,
    title: 'ClientContractListing',
    meta: {
      requiresAuth: true
    }
  },{
    path: '/cargoclient/services',
    name: 'cargoclient-services',
    component: ClientServicesListing,
    title: 'cargoclient-services',
    meta: {
      requiresAuth: true
    }
  },{
    path: '/cargoclient/annexures',
    name: 'cargoclient-annexures',
    component: ClientAnnexuresListing,
    title: 'cargoclient-annexures',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cargoclient/rates',
    name: 'cargoclient-rates',
    component: ClientRatesListing,
    title: 'cargoclient-rates',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cargoclient/termsandcondition',
    name: 'cargoclient-termsandcondition',
    component: ClientTCListing,
    title: 'cargoclient-termsandcondition',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cargoclient/uploadlocations',
    name: 'cargoclient-clientlocations',
    component: ClientLocations,
    title: 'cargoclient-clientlocations',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cargoclient/clienthubs',
    name: 'cargoclient-clienthubs',
    component: ClientHubs,
    title: 'cargoclient-clienthubs',
    meta: {
      requiresAuth: true
    }
  },
];



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/router/index.js